import React from "react";
import { BeakerIcon } from "./icons";

interface BreakScreenProps {
  score: number;
  onContinue: () => void;
}

const BreakScreen: React.FC<BreakScreenProps> = ({ score, onContinue }) => {
  return (
    <div className="flex flex-col items-center justify-center text-center p-8 bg-white rounded-2xl shadow-2xl max-w-2xl mx-auto border-4 border-teal-500">
      <BeakerIcon />
      <h1 className="text-4xl font-bold text-gray-800 mt-4 mb-2">
        Round 1 Complete!
      </h1>
      <p className="text-2xl text-gray-600 mb-6">Your score so far: {score}</p>
      <div className="my-4 p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded-r-lg w-full">
        <p className="text-lg font-semibold text-yellow-800">
          Get ready for Round 2. These questions are harder.
        </p>
      </div>
      <button
        onClick={onContinue}
        className="mt-4 bg-teal-500 text-white font-bold py-3 px-8 rounded-lg text-xl hover:bg-teal-600 transition-transform transform hover:scale-105 shadow-lg"
      >
        Continue to Round 2
      </button>
    </div>
  );
};

export default BreakScreen;
